import React from "react";
import "./not-authorized.css";
import { MainLayout } from "@containers/";

const NotAuthorized = () => {
  return (
    <MainLayout>
      <p className="label blueLabel">
        Lo sentimos! Tu cuenta no está autorizada para acceder al aplicativo.
      </p>
      <p className="label redLabel">
        Por favor, comunícate con tu Responsable para que solicite el permiso
        mediante HelpDesk, en la Categoría: “GESTION PROYECTOS – Proyecta
        Tecnología” y procederemos a gestionarlos, gracias.
      </p>
      <br />
      <br />
      <p className="label blueLabel">
        Sorry! You are not allowed to use this application.
      </p>
      <p className="label redLabel">
        Please, ask your Referent to write a HelpDesk petition, with the
        category: “GESTION PROYECTOS – Proyecta Tecnología” so we can grant your
        access.
      </p>
    </MainLayout>
  );
};
export default NotAuthorized;
